import React, { useId } from "react";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";

const CX1 = 118;
const CX2 = 202;
const CY = 100;
const R = 78;
const INTERSECT_FILL = "#a8d5ba";
const LINE_DY = 12;
const FONT_SIZE = 10;

const labelStyle = {
  fontSize: FONT_SIZE,
  fill: "#111",
  fontFamily: "inherit",
};

const VennSideLabel = ({ x, y, lines, clipUrl }) => (
  <text x={x} y={y} textAnchor="middle" style={labelStyle} clipPath={clipUrl}>
    {lines.map((line, index) => (
      <tspan key={index} x={x} dy={index === 0 ? 0 : LINE_DY}>
        {line}
      </tspan>
    ))}
  </text>
);

const centerY = (lineCount) => CY - ((lineCount - 1) * LINE_DY) / 2 + 1;

const MensajeVennDiagram = () => {
  const { t } = useTranslation();
  const uid = useId().replace(/:/g, "");
  const intersectClipId = `mensaje-venn-intersect-${uid}`;
  const leftCircleClipId = `mensaje-venn-left-circle-${uid}`;
  const rightCircleClipId = `mensaje-venn-right-circle-${uid}`;

  const g = (key) => t(`crearMensajes.referenceGuide.mensajeVenn.${key}`);

  const leftLines = [g("leftLine1"), g("leftLine2"), g("leftLine3"), g("leftLine4")].filter(
    (line) => line && !line.startsWith("crearMensajes."),
  );
  const rightLines = [g("rightLine1"), g("rightLine2"), g("rightLine3")];

  return (
    <Box sx={{ width: "100%", display: "flex", justifyContent: "center", py: 0.5 }}>
      <svg
        viewBox="0 0 320 200"
        width="100%"
        maxWidth={340}
        aria-label={g("center")}
        role="img"
      >
        <defs>
          <clipPath id={intersectClipId}>
            <circle cx={CX1} cy={CY} r={R} />
          </clipPath>
          <clipPath id={leftCircleClipId}>
            <circle cx={CX1} cy={CY} r={R - 2} />
          </clipPath>
          <clipPath id={rightCircleClipId}>
            <circle cx={CX2} cy={CY} r={R - 2} />
          </clipPath>
        </defs>

        <circle cx={CX1} cy={CY} r={R} fill="#fff" stroke="#111" strokeWidth="1.75" />
        <circle cx={CX2} cy={CY} r={R} fill="#fff" stroke="#111" strokeWidth="1.75" />
        <circle
          cx={CX2}
          cy={CY}
          r={R}
          fill={INTERSECT_FILL}
          clipPath={`url(#${intersectClipId})`}
        />

        <VennSideLabel
          x={82}
          y={centerY(leftLines.length)}
          lines={leftLines}
          clipUrl={`url(#${leftCircleClipId})`}
        />
        <VennSideLabel
          x={238}
          y={centerY(rightLines.length)}
          lines={rightLines}
          clipUrl={`url(#${rightCircleClipId})`}
        />

        <text
          x={160}
          y={CY}
          textAnchor="middle"
          dominantBaseline="middle"
          fontSize="15"
          fontWeight="700"
          fill="#c62828"
          fontFamily="inherit"
          letterSpacing="0.6"
          transform={`rotate(-90 160 ${CY})`}
        >
          {g("center")}
        </text>
      </svg>
    </Box>
  );
};

export default MensajeVennDiagram;
